import { render, staticRenderFns } from "./BodyPartDelete.vue?vue&type=template&id=0e879bbc&"
import script from "./BodyPartDelete.vue?vue&type=script&lang=js&"
export * from "./BodyPartDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports